<div class="s__faq-item" [class.s__faq-item--expanded]="expanded()" [attr.id]="id()">
  <button
    class="s__faq-item__trigger"
    type="button"
    [id]="triggerId"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="panelId"
    (click)="toggle()"
  >
    <span class="s__faq-item__question">{{ question() }}</span>
    <span class="s__faq-item__icon" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 8 10 12 14 8"/></svg>
    </span>
  </button>
  <div
    class="s__faq-item__panel"
    [id]="panelId"
    role="region"
    [attr.aria-labelledby]="triggerId"
  >
    <div class="s__faq-item__answer">
      <div class="s__faq-item__answer-content" [innerHTML]="renderedAnswer()"></div>
    </div>
  </div>
</div>
